const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/$/, '');
const API_URL = `${API_BASE_URL}`;

export { API_BASE_URL };
export default API_URL;